import { RouteComponentProps } from 'react-router'
import { Constraints, StyleProps } from '@touche-lts/panel-ui/dist'

interface MatchParams {
  code: string
}

export interface SignUpPageProps
  extends StyleProps,
    RouteComponentProps<MatchParams> {}

export interface SignUpForm {
  firstName: string
  lastName: string
  password: string
  confirmPassword: string
}

export const signUpFormConstraints: Constraints<SignUpForm> = {
  firstName: {
    presence: true,
    length: { minimum: 2 }
  },
  lastName: {
    presence: true,
    length: { minimum: 2 }
  },
  password: {
    presence: true,
    length: { minimum: 2 }
  },
  confirmPassword: {
    equality: 'password'
  }
}
